'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button } from '@/shared/components/ui';
import { applySelectionDiff, DataTable } from '@/shared/components/ui/common/DataTable';
import type { ColumnDef } from '@/shared/components/ui/common/DataTable';
import { FeatherClock, FeatherPause, FeatherPlay } from '@subframe/core';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { NegociacaoListRow } from '@/features/negociacoes/types/negociacoesUiTypes';
import type { LoteCompactTableProps } from '../../types/lote.types';
const getDaysOpen = (createdAt: string) => Math.floor((new Date().getTime() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24));
export function LoteCompactTable(t0) {
  const $ = _c(23);
  const {
    items,
    selectedIds,
    onToggleSelect,
    onRowClick,
    onPauseClick,
    onResumeClick,
    colorClass
  } = t0;
  let t1;
  if ($[0] !== onToggleSelect || $[1] !== selectedIds) {
    t1 = next => applySelectionDiff(selectedIds, next, onToggleSelect);
    $[0] = onToggleSelect;
    $[1] = selectedIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onSelectionChange = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      id: "client",
      header: "Cliente",
      cell: _temp
    };
    t3 = {
      id: "status",
      header: "Status",
      cell: _temp2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== colorClass) {
    t4 = {
      id: "temperature",
      header: "Temperatura",
      headerClassName: "max-md:hidden",
      cellClassName: "max-md:hidden",
      cell: item_1 => <span className={`text-caption-bold font-caption-bold ${colorClass}`}>{item_1.temperature}</span>
    };
    $[5] = colorClass;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      id: "days",
      header: "Dias",
      headerClassName: "max-md:hidden",
      cellClassName: "max-md:hidden",
      cell: _temp3
    };
    t6 = {
      id: "lastActivity",
      header: "\xDAltima atividade",
      headerClassName: "max-lg:hidden",
      cellClassName: "max-lg:hidden",
      cell: _temp4
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onPauseClick || $[10] !== onResumeClick) {
    t7 = {
      id: "actions",
      header: "A\xE7\xF5es",
      width: "w-24",
      cell: item_4 => item_4.isPaused ? <Button variant="neutral-tertiary" size="small" icon={<FeatherPlay className="h-3.5 w-3.5" />} onClick={e => {
        e.stopPropagation();
        onResumeClick(item_4.id);
      }} /> : <Button variant="neutral-tertiary" size="small" icon={<FeatherPause className="h-3.5 w-3.5" />} onClick={e_0 => {
        e_0.stopPropagation();
        onPauseClick(item_4.id);
      }} />
    };
    $[9] = onPauseClick;
    $[10] = onResumeClick;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = [t2, t3, t4, t5, t6, t7];
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const columns = t8;
  let t9;
  if ($[15] !== onRowClick) {
    t9 = item_6 => onRowClick(item_6);
    $[15] = onRowClick;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== columns || $[18] !== items || $[19] !== onSelectionChange || $[20] !== selectedIds || $[21] !== t9) {
    t10 = <DataTable data={items} columns={columns} getRowId={_temp5} selectionMode="multiple" selectedIds={selectedIds} onSelectionChange={onSelectionChange} onRowClick={t9} />;
    $[17] = columns;
    $[18] = items;
    $[19] = onSelectionChange;
    $[20] = selectedIds;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp5(item_5) {
  return item_5.id;
}
function _temp4(item_3) {
  const d = item_3.createdAt ? new Date(item_3.createdAt) : null;
  const label = d && !isNaN(d.getTime()) ? formatDistanceToNow(d, {
    addSuffix: true,
    locale: ptBR
  }) : "\u2014";
  return <span className="text-caption font-caption text-subtext-color">{label}</span>;
}
function _temp3(item_2) {
  const daysOpen = item_2.createdAt ? getDaysOpen(item_2.createdAt) : null;
  return <div className="text-subtext-color flex items-center gap-1"><FeatherClock className="h-3.5 w-3.5" /><span className="text-caption font-caption">{daysOpen != null ? `${daysOpen}d` : "\u2014"}</span></div>;
}
function _temp2(item_0) {
  return <Badge variant={item_0.statusVariant}>{item_0.status}</Badge>;
}
function _temp(item) {
  return <div className="flex flex-col gap-0.5"><span className="text-body-bold font-body-bold text-default-font line-clamp-1">{item.client}</span><span className="text-caption font-caption text-subtext-color line-clamp-1">{item.negotiationName}</span></div>;
}